import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Grid } from "semantic-ui-react";

import { socket } from "../../../../lib/socketio";
import CalcColumn from "../../../Monitor/CalcColumns";
import Footer from "../../Footer";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../../actions/navActions";

const CalcParm1_MAIN = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 41 }, { display_id: 1 }]);
      socket.on("receive tag names", (data) => {
        // update 250513, sort numeric
        data.tags_data.sort((a, b) =>
          a.tag_display_name.localeCompare(b.tag_display_name, undefined, {
            numeric: true,
          }),
        );
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 1 ? [t] : []));
  FooterTags.sort(
      (a, b) => a.id - b.id,
  );


  const GenTags = tags.flatMap((t) =>
    // t.page_name === 'Calculated Parameters/Events (A-H)' ? [t] : []);
    t.display_id === 41 ? [t] : [],
  );

  const display = GenTags.map((t) => t.page_name);

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const rows = Math.round(GenTags.length / 4) + 1;
  const columns = [];
  const length = GenTags.length;
  let i = 0;
  while (i < length) {
    columns.push(GenTags.slice(i, i + rows));
    i += rows;
  }

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      <Grid
        width="1800px"
        inverted
        divided
        centered
        columns="equal"
        style={styles.grid}
      >
        <Grid.Column style={{ maxWidth: "1800px" }}>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            {columns.map((c, i) => (
              <CalcColumn index={i} column={c} data={data} option={1} />
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
      <div style={{ marginTop: "25px" }}>
        <Footer tags={FooterTags} data={data} option={"MAIN"} />
      </div>
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "20px",
    marginTop: "10px",
  },
};

export default CalcParm1_MAIN;
